import { generatePath } from 'react-router';
import type { EnumUserRouteType } from '@components-member/userRoutes/enums';
import { replaceNullValuesWithString } from '@utils/replaceNullValuesWithString.util';

export interface IUserRouteProps {
  [paramName: string]: string | number | boolean | null | undefined;
}
interface IUserRoute<T> {
  /** @deprecated please use getPath instead */
  getPathPattern: (start?: number, end?: number) => string;
  getPath: (props: T) => string;
}

/**
 * userRoute is a closure with two arguments and generic type.
 *
 * @param pathPattern is a required argument and used to set the relative path pattern provided as a path attribute to
 *     the React Route component.
 * @param getPath is optional argument. If it is not set will be used default path getPath method from closure where
 *      one argument which contains an object with corresponding params for the pattern to use.
 *      If provided params and path don’t match, an error will be thrown.
 *      You can pass second argument with your own function and logic if needed,
 */
export const userRoute = <T extends IUserRouteProps>(pathPattern: EnumUserRouteType): IUserRoute<T> => {
  return {
    getPathPattern: (start?: number, end?: number): EnumUserRouteType => {
      if (typeof start === undefined && typeof end === undefined) {
        return pathPattern;
      } else {
        return pathPattern.split('/').slice(start, end).join('/') as EnumUserRouteType;
      }
    },
    getPath: (props: T) =>
      Object.keys(props ?? {}).length > 0
        ? generatePath(pathPattern, replaceNullValuesWithString(props as never))
        : pathPattern,
  };
};
